import React, { Component } from 'react';
import { Title } from 'bloomer/lib/elements/Title';
import moment from 'moment';
import { Section } from 'bloomer/lib/layout/Section';
import EditableEnrichment from './EditableEnrichment';

interface PropTypes {
  enrichmentData: Enrichment[];
  aNumber: Ianimal['aNumber'];
  refresh: () => void;
}

interface StateTypes {
  editMode: boolean;
}

class AnimalEditableEnrichment extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    editMode: false,
  };

  toggleEdit = () => this.setState({ editMode: !this.state.editMode });
  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };
  render() {
    const { enrichmentData, aNumber } = this.props;
    const name = enrichmentData[0].animalName;

    return (
      <Section>
        <Title tag="h3">
          {name} A#{aNumber}
        </Title>
        {enrichmentData
          .sort((a, b) => moment(a.timeReturned).unix() - moment(b.timeReturned).unix())
          .map((entry, i) => (
            <EditableEnrichment
              aNumber={entry.aNumber}
              key={`editable-${entry.aNumber}-${moment(entry.timeReturned).unix()}`}
              enrichment={entry}
              i={i}
              refresh={this.props.refresh}
            />
          ))}
      </Section>
    );
  }
}

export default AnimalEditableEnrichment;
